import { Component, OnInit } from '@angular/core';
import { BarraGovernoService } from '../../services/barra-governo.service';
import { RodapeService } from '../../services/rodape.service';

@Component({
  selector: 'app-rodape',
  templateUrl: './rodape.component.html',
  styleUrls: ['./rodape.component.scss']
})
export class RodapeComponent implements OnInit {

  rodape: any;

  constructor(
    private rodapeService: RodapeService
  ) { }

  async ngOnInit() {
    this.rodape = await this.rodapeService.get();
    this.rodape.imagens.forEach((imagem: any) => {
      const arraySplit = imagem.arquivo.url.split('http://');
      if (arraySplit.length > 1) {
        imagem.arquivo.url = 'https://' + arraySplit[1];
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/rodape/rodape.component.ts